export default __webpack_public_path__ + "static/media/stylist_image_2.c588acaf.webp";